import AppSwitch from 'navigation/switch';

function App() {
  return <AppSwitch />;
}

export default App;
